export enum LoginProgress {
  initialization,
  transactionPending,
  transactionSuccess,
  metamaskNotDetected,
  apiIssue,
}
